<template>
  <section id="about">
    <h2 class="section-title">About Me</h2>
    <div class="bento-grid">
      <div class="bento-item profile">
        <h3>Hello!</h3>
        <p>
          상명대학교 휴먼AI공학과를 졸업하고,<br />
          현재 백엔드 개발자로 취업을 준비 중입니다. <br />
          <br />
          <strong>"왜?"</strong>라는 질문을 던지며<br />
          기술적으로 개선하는 과정을 즐깁니다.
        </p>
      </div>

      <div class="badges-area">
        <div class="bento-item badge-box">
          <div class="badge-content">
            <span class="badge-value">4+</span>
            <span class="badge-label">Services<br />Launched</span>
          </div>
        </div>

        <div class="bento-item badge-box">
          <div class="badge-content">
            <span class="badge-value small-text">정보처리기사</span>
            <span class="badge-label">License</span>
          </div>
        </div>

        <div class="bento-item badge-box">
          <div class="badge-content">
            <span class="badge-value">IH</span>
            <span class="badge-label">OPIc<br />English</span>
          </div>
        </div>
      </div>

      <div class="bento-item awards">
        <h3 class="card-title">Awards</h3>
        <ul>
          <li>
            <span>상명대학교 2024 캡스톤 경진대회</span>
            <strong>대상</strong>
          </li>
          <li>
            <span>상명대학교 2024 졸업 포트폴리오 경진대회</span>
            <strong>최우수상</strong>
          </li>
          <li>
            <span>상명대학교 코딩 프로젝트 공모전</span>
            <strong>공모전 수상</strong>
          </li>
          <li>
            <span>UMC 5기 해커톤</span>
            <strong>3등 수상</strong>
          </li>
          <li>
            <span>멋쟁이 사자처럼 단풍톤 (해커톤)</span>
            <strong>최우수상 수상</strong>
          </li>
        </ul>
      </div>

      <div class="bento-item experience">
        <h3 class="card-title">Education & Experience</h3>

        <div class="list-item">
          <span class="year">2019 - 2025</span>
          <div>
            <strong>상명대학교 (서울)</strong>
            <p class="sub">휴먼AI공학과 (3.61/4.5)</p>
          </div>
        </div>

        <div class="list-item">
          <span class="year">2025</span>
          <div>
            <strong>KB국민은행 IT's Your Life</strong>
            <p class="sub">6기 수료 (우수 훈련생)</p>
          </div>
        </div>

        <div class="list-item">
          <span class="year">2023 - 2024</span>
          <div>
            <strong>UMC 대학생 개발 연합 동아리</strong>
            <p class="sub">Server Part / 회장</p>
          </div>
        </div>

        <div class="list-item">
          <span class="year">2022</span>
          <div>
            <strong>멋쟁이사자처럼 대학 10기</strong>
            <p class="sub">해커톤 최우수상</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: "AboutMe" };
</script>

<style scoped>
.section-title {
  font-size: 3rem;
  margin-bottom: 50px;
  color: var(--text-primary);
}

.bento-grid {
  display: grid;
  /* 왼쪽(수상내역이 내용이 김)을 조금 더 넓게 설정 */
  grid-template-columns: 1.3fr 1fr;
  /* 행 높이는 내용에 따라 자동 조절 */
  grid-template-rows: auto auto;
  gap: 20px;
}

.bento-item {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 24px;
  padding: 30px;
  box-shadow: var(--card-shadow);
  transition: transform 0.3s ease, border-color 0.3s ease;
}

.bento-item:hover {
  transform: translateY(-5px);
  border-color: var(--accent-color);
}

/* --- Grid Positioning (핵심 변경 사항) --- */

/* 1. Profile (좌측 상단) */
.profile {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
}

/* 2. Badges Area (우측 상단) - 이동됨 */
.badges-area {
  grid-column: 2 / 3;
  grid-row: 1 / 2;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* 3개 균등 분할 */
  gap: 12px;
}

/* 3. Awards (좌측 하단) */
.awards {
  grid-column: 1 / 2;
  grid-row: 2 / 3;
}

/* 4. Experience (우측 하단) - 이동됨 */
.experience {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
}

/* --- Content Styles --- */
.card-title {
  font-size: 1.1rem;
  margin-bottom: 25px;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 700;
}

/* Profile Text */
.profile p {
  font-size: 1.1rem;
  color: var(--text-secondary);
  line-height: 1.7;
}

/* Experience List Style */
.list-item {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
}
.list-item:last-child {
  margin-bottom: 0;
}
.year {
  font-family: "JetBrains Mono", monospace;
  color: var(--accent-color);
  font-size: 0.85rem;
  min-width: 85px;
  padding-top: 3px;
}
.list-item strong {
  display: block;
  font-size: 1rem;
  margin-bottom: 4px;
}
.sub {
  font-size: 0.9rem;
  color: var(--text-tertiary);
  margin: 0;
}

/* Awards List Style */
.awards ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.awards li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px dashed var(--border-color);
  color: var(--text-secondary);
}
.awards li:last-child {
  border-bottom: none;
}
.awards li strong {
  color: var(--accent-color);
  white-space: nowrap; /* 상장 이름 줄바꿈 방지 */
  margin-left: 10px;
}

/* --- Badge Box Styles --- */
.badge-box {
  padding: 15px 10px; /* 패딩을 약간 줄여서 우측 상단 공간에 맞춤 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: var(--bg-secondary);
  height: 100%; /* 부모 그리드 높이 채우기 */
  box-sizing: border-box;
}

.badge-box.highlight {
  background: linear-gradient(
    135deg,
    var(--bg-secondary) 0%,
    rgba(79, 70, 229, 0.05) 100%
  );
  border-color: var(--accent-color);
}

.badge-value {
  display: block;
  font-size: 1.6rem; /* 폰트 사이즈 약간 조정 */
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1.1;
  margin-bottom: 5px;
}

.badge-value.small-text {
  font-size: 1rem;
  word-break: keep-all;
}

.badge-label {
  font-size: 0.75rem;
  color: var(--text-tertiary);
  font-weight: 500;
  line-height: 1.3;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .bento-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }

  /* 모바일에서는 순서를 아래와 같이 변경 (프로필 -> 뱃지 -> 경력 -> 수상) */
  .profile {
    grid-row: 1;
    grid-column: 1;
  }
  .badges-area {
    grid-row: 2;
    grid-column: 1;
  }
  .experience {
    grid-row: 3;
    grid-column: 1;
  }
  .awards {
    grid-row: 4;
    grid-column: 1;
  }

  .badges-area {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media (max-width: 480px) {
  .badges-area {
    grid-template-columns: 1fr; /* 화면 아주 작으면 세로로 쌓기 */
    gap: 10px;
  }
  .badge-box {
    flex-direction: row;
    justify-content: flex-start;
    gap: 20px;
    text-align: left;
    padding: 20px;
  }
}
</style>
